<template>
    <vue-draggable-resizable class="tag"
        :w="size.width" :h="size.height" :x="axis.x" :y="axis.y" :z-index="9"
        :draggable="false" :resizable="false"> 
            <div v-if="value.type === 'text-employer'" class="field-input-wrap employerTag" >
                <v-text-field v-model="content" readonly flat solo class="v-input--small" />
            </div>
            <div v-if="value.type === 'text-employee'" class="field-input-wrap employeeTag">
                <v-text-field v-model="content" outlined placeholder="텍스트를 입력해주세요" @change="update" class="v-input--small"/>
            </div>
            <div v-if="value.type === 'check'" class="field-input-wrap employeeTag" >
                <div class="checkbox-wrap">
                    <v-checkbox v-model="content" hide-details @change="update"/>
                </div>  
            </div>
            <!-- <div v-if="value.type === 'file'">
                <v-file-input v-model="content"/>
            </div> -->
            <div v-if="value.type === 'canvas'" class="field-input-wrap employeeTag">
            <p v-if="!show" @mouseover="()=>{this.show=true}">전자서명을 해주세요</p>
            <canvas v-else ref="myCanvas" :width="size.width" :height="size.height" 
                @mousedown="beginDrawing" @mousemove="keepDrawing" @mouseup="stopDrawing"
                @touchstart="startTouching" @touchmove="moveTouching" @touchend="stopTouching">
            </canvas>
            </div>
    </vue-draggable-resizable>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'

export default {
    components:{
        VueDraggableResizable
    },
    props:{
        value: { type: Object, default: ()=>({}) }
    },
    data(){
        return{
            axis: {
                x: this.value?.axis?.x || 0,
                y: this.value?.axis?.y || 0,
            },
            size: {
                width: this.value?.size?.w || 100,
                height: this.value?.size?.h || 50,
            },
            content: this.value?.content || null,

            //canvas
            show: false,
            x: 0,
            y: 0,
            isDrawing: false,
        }               
    },
    mounted(){
        },
    methods:{
        update(value){
            this.$emit('update', Object.assign(this.value, { content: value }));
        },
        drawLine(x1, y1, x2, y2) {
            let canvas = this.$refs["myCanvas"];
            let ctx = canvas.getContext("2d")
            ctx.beginPath();
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 1;
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.closePath();
        },
        beginDrawing(e) {
            this.x = e.offsetX;
            this.y = e.offsetY;
            this.isDrawing = true;
        },
        keepDrawing(e) {
            if (this.isDrawing === true) {
                this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
                this.x = e.offsetX;
                this.y = e.offsetY;
            }
        },
        stopDrawing(e) {
            if (this.isDrawing === true) {
                this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
                this.x = 0;
                this.y = 0;
                this.isDrawing = false;
                this.canvasToImg();
            }
        },

        // 모바일 canvas 그리기
        startTouching(e) {
            let canvas = this.$refs["myCanvas"];
            let ctx = canvas.getContext("2d")

            e.preventDefault(e)
            this.isDrawing = true;
            const touch = e.touches[0];
            const rect = canvas.getBoundingClientRect();
            
            ctx.beginPath();
            ctx.moveTo(touch.clientX - rect.left, touch.clientY - rect.top);
            ctx.strokeStyle = 'black';
            ctx.lineWidth = 1;
        },
        moveTouching(e) {
            if(!this.isDrawing) return;
            let canvas = this.$refs["myCanvas"];
            let ctx = canvas.getContext("2d")
            const rect = canvas.getBoundingClientRect();
            const touch = e.touches[0];

            ctx.lineTo(touch.clientX - rect.left, touch.clientY - rect.top);
            ctx.stroke();
        },
        stopTouching(e) {
            this.canvasToImg();
        },
        canvasToImg() {
            let c = this.$refs["myCanvas"];
            const base64Url = c.toDataURL();
            this.content = base64Url;
            
            this.update(this.content);
        }
    },
}
</script>

<style>
/* position abosulte 제거 시 좌표값 망가짐 */
.tag{
    position: absolute;
}
.employeeTag{
    border: 1px solid red;
}
</style>